export default __webpack_public_path__ + "static/media/ic-changefund.72622a65.png";